<template>
    <app-data-table
        :fields="fields"
        :items="data.data || []"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="code" slot-scope="{ item }">
            <span class="badge badge-info" v-if="item.code">{{ item.code }}</span>
            <span v-else class="text-muted">N/A</span>
        </template>

        <template slot="title" slot-scope="{ item }">
            <span v-if="item.deleted_at" class="text-muted" style="text-decoration: line-through;">
                {{ item.title }}
            </span>
            <span v-else>{{ item.title }}</span>
            <span v-if="item.deleted_at" class="badge badge-warning ml-2">Deshabilitada</span>
        </template>

        <template slot="client.name" slot-scope="{ item }">
            {{ item.client ? item.client.name : 'N/A' }}
        </template>

        <template slot="user.name" slot-scope="{ item }">
            {{ item.user ? item.user.name : 'N/A' }}
        </template>

        <template slot="status" slot-scope="{ item }">
            <span :class="getStatusBadgeClass(item.status)">
                {{ getStatusLabel(item.status) }}
            </span>
        </template>

        <template slot="total_cop" slot-scope="{ item }">
            {{ formatCurrency(item.total_cop) }}
        </template>

        <template slot="total_usd" slot-scope="{ item }">
            {{ formatCurrency(item.total_usd, 'USD') }}
        </template>

        <template slot="created_at" slot-scope="{ item }">
            {{ item.created_at | date }}
        </template>

        <template slot="actions" slot-scope="{ item }">
            <b-button variant="info" size="sm" v-if="userCan('view-cotizaciones')" @click="onView(item)" title="Ver">
                <i class="fa fa-eye" aria-hidden="true"></i>
            </b-button>
            <b-button 
                v-if="!item.deleted_at && userCan('update-cotizaciones')"
                variant="primary" 
                size="sm" 
                @click="onEdit(item)" 
                title="Editar"
            >
                <i class="fa fa-edit" aria-hidden="true"></i>
            </b-button>
            <b-button variant="secondary" size="sm" v-if="userCan('view-cotizaciones')" @click="onViewHistory(item)" title="Ver Historial">
                <i class="fa fa-history" aria-hidden="true"></i>
            </b-button>
            <b-button 
                v-if="!item.deleted_at && userCan('delete-cotizaciones')"
                variant="warning" 
                size="sm" 
                @click="onDelete(item)" 
                title="Deshabilitar"
            >
                <i class="fa fa-ban" aria-hidden="true"></i>
            </b-button>
            <b-button 
                v-if="item.deleted_at && userCan('update-cotizaciones')"
                variant="success" 
                size="sm" 
                @click="onRestore(item)" 
                title="Reactivar"
            >
                <i class="fa fa-undo" aria-hidden="true"></i>
            </b-button>
        </template>
    </app-data-table>
</template>
<script>
import { mixin } from '../../../../mixin';

export default {
    mixins: [mixin],
    props: {
        data: {
            type: Object,
            required: true
        },
        onChangePage: {
            type: Function,
            required: true
        },
        onEdit: {
            type: Function,
            required: true
        },
        onView: {
            type: Function,
            required: true
        },
        onViewHistory: {
            type: Function,
            required: true
        },
        onDelete: {
            type: Function,
            required: true
        },
        onRestore: {
            type: Function,
            required: false
        }
    },
    data() {
        return {
            fields: [
                { key: 'code', label: 'Código', sortable: true },
                { key: 'title', label: 'Título', sortable: true },
                { key: 'client.name', label: 'Cliente', sortable: false },
                { key: 'user.name', label: 'Creado por', sortable: false },
                { key: 'status', label: 'Estado', sortable: true },
                { key: 'total_cop', label: 'Total COP', sortable: true },
                { key: 'total_usd', label: 'Total USD', sortable: true },
                { key: 'created_at', label: 'Fecha Creación', sortable: true },
                { key: 'actions', label: 'Acciones', sortable: false }
            ]
        };
    },
    methods: {
        onSort(sortBy, sortDir) {
            this.$emit('sort', { sortBy, sortDir });
        },
        formatCurrency(value, currency = 'COP') {
            if (!value) return '$ 0,00';
            const formatter = new Intl.NumberFormat('es-CO', {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            return formatter.format(value);
        },
        getStatusLabel(status) {
            const labels = {
                'draft': 'Borrador',
                'sent': 'Enviada',
                'approved': 'Aprobada',
                'rejected': 'Rechazada',
                'canceled': 'Cancelada'
            };
            return labels[status] || status;
        },
        getStatusBadgeClass(status) {
            const classes = {
                'draft': 'badge badge-secondary',
                'sent': 'badge badge-info',
                'approved': 'badge badge-success',
                'rejected': 'badge badge-danger',
                'canceled': 'badge badge-warning'
            };
            return classes[status] || 'badge badge-secondary';
        }
    }
};
</script>

